import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Automation } from "../_types/automation";
import { AutomationCompany } from "../_types/automation-company";
@Injectable({
    providedIn: 'root',
})

export class AutomationsCompaniesService extends Service<AutomationCompany> {
  public override type = 'automationsCompanies';
  public override url = 'common/automationCompanies';
}
